import React from "react";
import Layout from "../Component/Layout/Layout";
import BannerSection from "../Component/BannerSection";
import AboutDetail from "../Component/About/AboutDetail";
import OurGoals from "../Component/About/OurGoals";
import WhyChooseUs from "../Component/About/WhyChooseUs";
// import Process from "../Component/About/Process";
// import Testimonial from "../Component/Home/Testimonial.jsx";
import WhatWeOffer from "../Component/About/WhatWeOffer.jsx";

const About = () => {
  return (
    <Layout>
      <BannerSection heading="About Us" image="/images/about_banner.jpg" description="About Us" />
      <AboutDetail />
      <WhatWeOffer />
      <OurGoals />
      <WhyChooseUs />
      {/* <Process /> */}
      {/* <Testimonial /> */}
    </Layout>
  );
};

export default About;
